import { Graphics } from 'pixi.js';
import { SegmentDivisionType, SegmentJoint } from '@/types/creator';
import ConfigurationRenderer from '../ConfigurationRenderer';
import DrawableObject from './DrawableObject';
import RENDERER_CONFIG from '@/configs/rendererConfig';

const { ROLLER_BOX, COLORS } = RENDERER_CONFIG;

class RollerBox extends DrawableObject {
	private prevJoint?: SegmentJoint;
	private nextJoint?: SegmentJoint;
	private frame = new Graphics({
		zIndex: ROLLER_BOX.Z_INDEX,
	});

	constructor(
		renderer: ConfigurationRenderer,
		prevJoint?: SegmentJoint,
		nextJoint?: SegmentJoint
	) {
		super(renderer);
		this.prevJoint = prevJoint;
		this.nextJoint = nextJoint;
		this.container.addChild(this.frame);
	}

	draw() {
		const { width, height } = this.scaledDimensions;

		this.frame
			.moveTo(0, 0)
			.lineTo(width, 0)
			.moveTo(0, height)
			.lineTo(width, height);

		if (this.prevJoint?.divisionType !== SegmentDivisionType.NONE)
			this.frame.moveTo(0, 0).lineTo(0, height);

		if (this.nextJoint?.divisionType !== SegmentDivisionType.NONE)
			this.frame.moveTo(width, 0).lineTo(width, height);

		if (this.nextJoint?.driverJunction) {
			const half = ROLLER_BOX.DRIVER_JUNCTION_HALF_LENGTH;
			this.frame
				.moveTo(width - half, height / 2)
				.lineTo(width + half, height / 2);
		}

		this.frame.stroke({ color: COLORS.BLACK, pixelLine: true });
	}
}

export default RollerBox;
